'use client'

import { useEffect } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import getConfig from './CookieConsentConfig'
import addEventListeners from './CookieConsentListeners'
import { useCookies } from 'react-cookie'
import { COOKIE_NAME } from '@/components/Layout/aichat/config'
import { usePathname } from 'next/navigation'

/**
 * This example uses custom event listeners.
 * You can use either event listeners or callback functions:
 * https://cookieconsent.orestbida.com/advanced/callbacks-events.html
 */

const ResetCookieConsent = () => {
  CookieConsent.reset(true)
  CookieConsent.run(getConfig())
}

const CookieConsentComponent = () => {
  const [cookie, setCookie] = useCookies([COOKIE_NAME])
  const pathname = usePathname()
  useEffect(() => {
    if (!pathname?.includes('vote')) {
      addEventListeners(acceptCookies)
      CookieConsent.run(getConfig())
    }
  }, [pathname])
  const acceptCookies = () => {
    const randomId = Math.random().toString(36).substring(7)
    const expireDate = new Date()
    expireDate.setFullYear(expireDate.getFullYear() + 1)
    setCookie(
      COOKIE_NAME,
      { randomId, codeRetrieved: false },
      { expires: expireDate },
    )
  }

  return (
    <div>
      {/* <button type="button" onClick={CookieConsent.showPreferences}>
        Manage cookie preferences
      </button>
      <button type="button" onClick={ResetCookieConsent}>
        Reset cookie consent
      </button> */}
    </div>
  )
}

export default CookieConsentComponent
